import axios from 'axios';

const api = axios.create({
  baseURL: 'https://pey-backend.vercel.app',
})

export default api;
